import { lazy } from 'react';
import { AppRoutes } from './routes-config';
import { Config } from '@/utils/config';

const HomePage = lazy(() => import('./home'));
const DocumentAgentPage = lazy(() => import('./document-agent'));
const DocumentExpiredPage = lazy(() => import('./document-expired'));
const PageNotFound = lazy(() => import('./page-not-found'));
const PasswordDocumentRecipientViewPage = lazy(() => import('./password-document-recipient-view'));
const PreviewPage = lazy(() => import('./preview'));
const TemplatePreviewPage = lazy(() => import('./template-preview'));
const TestPreviewPage = lazy(() => import('./test-preview'));
const SimpleJsonPlaygroundPage = lazy(() => import('./simple-json-playground'));
const ViewPage = lazy(() => import('./view'));
const ExportPage = lazy(() => import('./export'));

export const routes: Route[] = [
  { Component: HomePage, index: true, path: AppRoutes.home() },
  { Component: DocumentAgentPage, path: AppRoutes.documentAgent() },
  { Component: DocumentExpiredPage, path: AppRoutes.documentExpired(), disableAuth: true },
  {
    Component: PasswordDocumentRecipientViewPage,
    path: AppRoutes.passwordDocumentRecipientView(),
    disableAuth: true,
  },
  { Component: PreviewPage, path: AppRoutes.preview() },
  { Component: ViewPage, path: AppRoutes.view(), disableAuth: true },
  { Component: ViewPage, path: AppRoutes.share(), disableAuth: true },
  { Component: TemplatePreviewPage, path: AppRoutes.templatePreview(), disableAuth: true },
  { Component: TestPreviewPage, path: AppRoutes.testPreview(), disableAuth: true },
  // Internal tool, not served in production.
  ...(Config.IS_PRODUCTION_DEPLOYMENT
    ? []
    : [
        {
          Component: SimpleJsonPlaygroundPage,
          path: AppRoutes.simpleJsonPlayground(),
          disableAuth: true,
        },
      ]),
  { Component: ExportPage, path: AppRoutes.export(), disableAuth: true },
  { Component: PageNotFound, path: AppRoutes.pageNotFound(), disableAuth: true },
];
